module.exports = "<p>基本用法</p>\n";